/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Card, CardBody, Col } from 'reactstrap';
import {
    BarChart, Bar, XAxis, YAxis, LabelList, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from 'recharts';
import { setCurrencyFormat, colorArray } from '../../../../utils/helpers';

export default function YearlyBarChart({
    dir, currentYearMonthDayWise, showTitle, allCategories,
    height, isSalesKey, index, month, category }) {
    const { t } = useTranslation('common');
    const [data, setData] = useState();
    const dataToShow = []

    month.map((item, eleIndex) => (
        dataToShow.push({
            monthyear: item,
            amount: currentYearMonthDayWise?.[item]?.Amount,
        })
    ))
    const getRandomColor = () => {
        const letters = '0123456789ABCDEF'.split('');
        let fillColor = '#';
        for (let i = 0; i < 6; i += 1) {
            fillColor += letters[Math.floor(Math.random() * 16)];
        }
        return fillColor;
    }

    return (
        <Col xs={12}>
            <Card >
                <CardBody style={{ marginTop: '50px' }}>
                    {showTitle ? <div className="card__title">
                        <h5 className="bold-text">{t('Category Sales')}</h5>
                    </div> : null}
                    <div dir="ltr">
                        <ResponsiveContainer height={height}>
                            <BarChart
                                data={dataToShow}
                                margin={{
                                    top: 50, rigth: 0, left: -15, bottom: 0,
                                }}
                            >
                                <XAxis dataKey="monthyear" reversed={dir === 'rtl'} />
                                <YAxis orientation={dir === 'rtl' ? 'right' : 'left'}
                                    tickFormatter={item => setCurrencyFormat(item, true)}
                                    width={90}
                                    tick
                                    allowDataOverflow
                                />
                                <CartesianGrid vertical={false} horizontal  stroke="#FF0000" strokeWidth={2} />
                                <Tooltip formatter={value => setCurrencyFormat(value, true)} />
                                <Legend />
                                <Bar
                                    stackId="a"
                                    fill={getRandomColor()}
                                    // fill="#8884d8"
                                    dataKey="amount"
                                    stroke="#000000"
                                    name={category}
                                    barSize={40}
                                ><LabelList dataKey="amount" formatter={value => setCurrencyFormat(value, true)} position="top" /></Bar>

                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </CardBody>
            </Card>
        </Col>
    );
};

YearlyBarChart.propTypes = {
    dir: PropTypes.string.isRequired,
    currentYearMonthDayWise: PropTypes.arrayOf({}).isRequired,
    allCategories: PropTypes.object.isRequired,
    height: PropTypes.number.isRequired,
    showTitle: PropTypes.bool,
    isSalesKey: PropTypes.string,
    index: PropTypes.number,
    month: PropTypes.object.isRequired,
    category: PropTypes.string,
}

YearlyBarChart.defaultProps = {
    isSalesKey: 'amount',
    showTitle: true,
    index: 0,
    category: 'Category Sales By Year'
}